import React from 'react';

/**
 * 配额提示框组件
 * @param {boolean} isOpen - 是否显示模态框
 * @param {function} onClose - 关闭模态框的回调函数
 * @param {string} title - 标题
 * @param {string[]} contentLines - 内容行数组
 * @param {string} warningText - 警告文本
 * @param {string} closeButtonText - 关闭按钮文本
 * @param {object} additionalButtons - 额外按钮配置数组
 */
const QuotaModal = ({ 
  isOpen, 
  onClose, 
  title = "Name Screening Quota Reached",
  contentLines = [
    "You've reached your screening quota for this billing period.",
    "Further searches are temporarily disabled."
  ],
  warningText = "Please contact the iCOMPASS Team to upgrade your plan.",
  closeButtonText = "Close",
  additionalButtons = []
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-xl font-bold text-red-600 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            {title}
          </h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="mb-4">
          <p className="text-gray-700">
            {contentLines.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < contentLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        </div>
        
        <div className="bg-yellow-50 p-4 rounded border border-yellow-200 mb-4">
          <p className="text-yellow-800">
            {warningText}
          </p>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
          >
            {closeButtonText}
          </button>
          {additionalButtons.map((button, index) => (
            <button
              key={index}
              onClick={button.onClick}
              className={button.className || "px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"}
            >
              {button.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuotaModal;
